import {httpsCallable} from "firebase/functions";
import {Auth, Functions} from "../../../firebase/firebase";
import {ManagerProps} from "../../../global/schemas/data/managers/manager";
import {useState, useEffect} from "react";

type OkRes = { status: "OK"; response: ManagerProps; domain?: string };
type ErrRes = { status: "Error"; message?: string; code?: number };
type Res = OkRes | ErrRes;

export async function callGetManager(managerID: string): Promise<ManagerProps> {
  /* const user = Auth.currentUser;
   if (!user) throw new Error("Ikke innlogget");
   const callerToken = await user.getIdToken();
   const callerID = user.uid;
 */
  const fn = httpsCallable(Functions, "call-admin-manager-getManager");

  const data = {
    //callerToken,
    //callerID,
    managerID
  };
  const res = (await fn(data)).data as Res;
  if (res.status === "OK") return res.response;
  throw new Error(res.message || `Feil (${res.code ?? "ukjent"})`);
}

export function useManager(managerId: string | undefined) {
  const [manager, setManager] = useState<ManagerProps | undefined | null>()
  useEffect(() => {
    if (!managerId) return;

    callGetManager(managerId).then((manager: ManagerProps) => {
      setManager(manager)
    });
  }, [managerId]);

  return manager;
}

